import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SylveraIcon = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 28 32",
    "data-testid": "sylvera-icon",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("g", {
      id: "Group 531",
      children: /*#__PURE__*/_jsxs("g", {
        id: "Group 531_2",
        children: [/*#__PURE__*/_jsx("path", {
          id: "Vector",
          d: "M4.8554 13.7028a9.2546 9.2546 0 0 0 .2784 2.2861 9.1534 9.1534 0 0 0 3.2587 4.9493 9.1468 9.1468 0 0 0 5.6066 1.9146v4.575h-.3535a13.7085 13.7085 0 0 1-8.632-3.3456 13.718 13.718 0 0 1-4.5393-8.0711 13.454 13.454 0 0 1-.192-2.2861 13.727 13.727 0 0 1 1.0433-5.2521 13.7226 13.7226 0 0 1 2.9732-4.4528 13.7163 13.7163 0 0 1 4.4504-2.9753A13.7122 13.7122 0 0 1 13.9991 0v4.575h-.3535a9.1475 9.1475 0 0 0-6.23 2.7955 9.1548 9.1548 0 0 0-2.5602 6.3323Z",
          fill: "#01311D"
        }), /*#__PURE__*/_jsx("path", {
          id: "Vector_2",
          d: "M27.7176 18.2742c0 1.8024-.3548 3.5872-1.0443 5.2524a13.7255 13.7255 0 0 1-2.974 4.4527 13.719 13.719 0 0 1-9.7013 4.02v-4.575h.3535a9.1477 9.1477 0 0 0 6.2375-2.8006 9.1551 9.1551 0 0 0 2.5555-6.3439 9.2584 9.2584 0 0 0-.2784-2.2861 9.156 9.156 0 0 0-3.2577-4.9454 9.15 9.15 0 0 0-5.602-1.9157V4.552h.3535a13.7109 13.7109 0 0 1 8.637 3.3507 13.7203 13.7203 0 0 1 4.537 8.0799c.1265.7572.188 1.5239.1837 2.2916Z",
          fill: "#3ACB5A"
        })]
      })
    })
  }));
};
export default SylveraIcon;